import { exportedSiteData, initApp, setSiteData, packageVersion } from './initApp';
import * as rxnanoIcons from './common/icons';
import * as rxnanoComponent from './common';
import { patch } from 'incremental-dom';
export { patch };
import { createElement, Fragment } from './incdom';
export var JSXFactory = {
    createElement: createElement,
    Fragment: Fragment
};
export * from './utils';
export * from './enums';
export * from './pixList';
export { modulePage } from './dynamic';
export { notFoundPage } from './notfound';
export { termsPages } from './pages/terms/termsPages';
export { contactPage } from './pages/contact';
export { pageChangeSubject, triggerPageChange, scrollObservable, mapLoadedObservable, linkClick, preloadMaps } from './rxjs';
export var render = function (f) { return f(); };
export * from './interfaces';
export { exportedSiteData, setSiteData, initApp, packageVersion, rxnanoIcons, rxnanoComponent };
//# sourceMappingURL=index.js.map